import { Controller } from "@hotwired/stimulus"

// Keeps the onboarding chat pane pinned to the right content. The pane holds the
// block explanation, the notices and the whole message history. Two behaviours
// share one scroller:
//
//   * New content (a message the user sent, a job broadcasting a system reply)
//     pins to the BOTTOM — seeing the system's answer matters more than keeping
//     an older scroll position.
//   * Opening a block from the sidebar swaps the explanation frame at the TOP of
//     the pane; there we scroll to the top so the freshly selected block's
//     details are the first thing the user sees.
//
// A MutationObserver re-pins to the bottom on every DOM change. When the
// explanation frame navigates (turbo:frame-load) we flip a one-shot flag so the
// navigation's own mutations pin to the top instead; the flag releases on the
// next frame so later message broadcasts resume pinning to the bottom.
export default class extends Controller {
  connect() {
    this.pinToTop = false
    this.scrollToBottom()
    this.observer = new MutationObserver(() => this.onMutation())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.onFrameLoad = this.onFrameLoad.bind(this)
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  onFrameLoad(event) {
    if (event.target.id !== "onboarding_explanation") return
    this.pinToTop = true
    this.scrollToTop()
    requestAnimationFrame(() => {
      this.pinToTop = false
      this.scrollToTop()
    })
  }

  onMutation() {
    if (this.pinToTop) {
      this.scrollToTop()
    } else {
      this.scrollToBottom()
    }
  }

  scrollToTop() {
    this.element.scrollTop = 0
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
